<template>
  <div class="common-page driver-workforce-management">
    <div class="left-box">
      <div class="left-content">
        <div
          class="list"
          v-for="(item, index) in dispatchDeptData"
          :key="index"
          :class="searchForm.deptId === item.deptId ? 'select-dispatch' : ''"
          @click="checkDispatch(item)">
          {{ item.deptName }}
        </div>
      </div>
    </div>
    <div class="right-box">
      <div class="search-table-box">
        <div class="list-box">
          <div class="list-box-num">{{ overview.driverNum }}</div>
          <div class="list-box-label">司机数量（人）</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">{{ overview.dispatcherNum }}</div>
          <div class="list-box-label">调度人数（人）</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">{{ overview.unAllocateDriverNum }}</div>
          <div class="list-box-label">待分配司机（人）</div>
        </div>
        <div class="list-box">
          <div class="list-box-num">{{ overview.dispatcherDriverRatio }}</div>
          <div class="list-box-label">调度司机比</div>
        </div>
      </div>
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="司机姓名:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.username"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="车牌号码:">
                <el-input
                  style="width: 100%"
                  clearable
                  v-model="searchForm.carNumber"
                  autocomplete="off"
                  placeholder="请输入" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="调度组:">
                <el-select style="width: 100%" clearable @click="handleChange" v-model="searchForm.deptId" placeholder="请选择">
                  <el-option
                    v-for="item in dispatchDeptData"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="责任调度:">
                <el-select style="width: 100%" clearable v-model="searchForm.dispatcherId" placeholder="请选择">
                  <el-option
                    v-for="item in peopleData"
                    :key="item.userId"
                    :label="item.username"
                    :value="item.userId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <div class="custom-tip">已选择 {{selectRows.length}} 人 <span class="fen-diao" @click="handleFenBatch">批量分配调度</span></div>
      </div>
      <div class="custom-table-box">
        <custom-table
          ref="customTable"
          :data="tableData"
          :column="tableColumn"
          :total="tableOptions.total"
          :loading="tableOptions.loading"
          :page="tableOptions.pageNumber"
          :size="tableOptions.pageSize"
          :selection="true"
          :is-reserve-selection="true"
          row-key="driverId"
          @pagination="handleSizeChange"
          @selectionChange="handleSelectionChange">
          <template v-slot:startCityName="{ row }">{{ row.startCityName }} - {{ row.endCityName }}</template>
          <template v-slot:dispatchDeptName="{ row }">
            <span class="common-status status-in-progress" v-if="row.dispatchDeptName">{{ row.dispatchDeptName }}</span>
            <span v-else class="colorff9f19">待分配</span>
          </template>
          <template v-slot:dispatcherName="{ row }">
            <span class="common-status status-in-progress" v-if="row.dispatcherName">{{ row.dispatcherName }}</span>
            <span v-else class="colorff9f19">待分配</span>
          </template>
          <template v-slot:operation="{ row }">
            <!--            <span class="operate-btn" @click.stop="handleDispatchDept(row)">分配调度组</span>-->
            <span class="operate-btn" @click.stop="handleDispatcher(row)">分配责任调度</span>
          </template>
        </custom-table>
      </div>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <batchAddOrEdit ref="batchAddOrEdit"></batchAddOrEdit>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import addOrEdit from "./addOrEdit.vue";
import batchAddOrEdit from "./batchAddOrEdit.vue";
import { deleteInfo, enableUser, getDispatchOverview, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import dayjs from "dayjs";
import { getDispatchDept, getDispatchDeptForUser } from "@/views/commonApi";
export default {
  name: "Staff-management",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    addOrEdit,
    batchAddOrEdit,
  },
  data() {
    return {
      getTableMethod: getPage,
      deleteMethod: deleteInfo,
      searchForm: {
        carNumber: "",
        deptId: "",
        dispatcherId: "",
        username: "",
      },
      peopleData: [],
      selectRows: [],
      dispatchDeptData: [],
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "司机姓名",
          prop: "username",
          show: true,
        },
        {
          label: "司机联系方式",
          prop: "phone",
          show: true,
        },
        {
          label: "车牌号码",
          prop: "carNumber",
          show: true,
        },
        {
          label: "车型",
          prop: "vehicleMode",
          show: true,
        },
        {
          label: "车长",
          prop: "vehicleLength",
          show: true,
        },
        {
          label: "运输路线",
          prop: "startCityName",
          scopeStatus: true,
          show: true,
        },
        {
          label: "所属调度组",
          prop: "dispatchDeptName",
          scopeStatus: true,
          show: true,
        },
        {
          label: "责任调度",
          prop: "dispatcherName",
          scopeStatus: true,
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "140px",
          scopeStatus: true,
          show: true,
        },
      ],
      selectDispatch: "",
      dispatchDeptDataAdd: [],
      overview: {},
    };
  },
  watch: {
    "searchForm.deptId": function (val) {
      if (val) {
        this.getPeople(val);
      } else {
        this.peopleData = []
      }

    },
  },
  created() {
    this.getDispatch();
    this.getOverview();
    // this.getPeople();
  },
  mounted() {},
  methods: {
    handleChange() {
      this.searchForm.dispatcherId = ""
    },
    handleSelectionChange(val) {
      this.selectRows = [...val]
    },
    handleFenBatch() {
      if (this.selectRows.length === 0) {
        this.$message.warning("请选择需要分配的司机")
        return
      }
      this.$refs.batchAddOrEdit.init(this.selectRows, this.dispatchDeptDataAdd);
    },
    handleReset() {
      this.searchForm.username = "";
      this.searchForm.dispatcherId = "";
      this.searchForm.carNumber = "";
      this.getTableData();
    },
    getPeople(val) {
      getDispatchDeptForUser(val).then((res) => {
        if (res.code === 200) {
          this.peopleData = res.data;
        }
      });
    },
    checkDispatch(item) {
      if (this.searchForm.deptId === item.deptId) {
        return;
      }
      this.searchForm.deptId = item.deptId;
      this.tableOptions.pageNumber = 1;
      this.getTableData();
      this.getOverview(this.searchForm.deptId);
      this.getPeople(this.searchForm.deptId);
    },
    getOverview(deptId) {
      getDispatchOverview(deptId).then((response) => {
        if (response.code === 200) {
          this.overview = response.data;
        }
      });
    },
    getDispatch() {
      getDispatchDept().then((res) => {
        if (res.code === 200) {
          this.dispatchDeptData = [
            // {
            //   deptId: "",
            //   deptName: "全部调度资源",
            // },
          ].concat(res.data);
          this.dispatchDeptDataAdd = res.data;
        }
      });
    },
    handleDispatcher(row) {
      this.$refs.addOrEdit.init(row, this.dispatchDeptDataAdd);
    },
  },
};
</script>
<style lang="scss" scoped>
.driver-workforce-management {
  display: flex;
  flex-direction: row;
  .left-box {
    width: 3rem;
    height: 100%;
    //background-color: #ffffff;
    flex-shrink: 0;
    padding: 0.2rem 0 0.2rem 0.2rem;
    box-sizing: border-box;
    .left-content {
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      border-radius: 0.08rem;
      padding: 0.2rem;
      box-sizing: border-box;
      .list {
        width: 100%;
        height: 0.4rem;
        color: #434343;
        display: flex;
        align-items: center;
        padding-left: 0.1rem;
        box-sizing: border-box;
        font-size: 0.16rem;
        cursor: pointer;
        border-radius: 0.04rem;
      }
      .select-dispatch {
        background: rgba(18, 105, 255, 0.05);
        color: #1269ff;
        position: relative;
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          width: 0.02rem;
          height: 100%;
          background-color: #1269ff;
        }
      }
    }
  }
  .right-box {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .search-table-box {
    display: flex;
    margin: 0 -0.1rem;
    margin-top: 0.2rem;
    .list-box {
      width: 25%;
      height: 0.9rem;
      border-radius: 0.08rem;
      background-color: #ffffff;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 0 0.1rem;
      .list-box-num {
        font-size: 0.24rem;
        color: #000000;
        padding-bottom: 0.1rem;
        font-weight: bold;
      }
      .list-box-label {
        font-size: 0.14rem;
        color: #434343;
      }
    }
  }
  .custom-table-box {
    padding-top: 0rem;
  }
  .custom-tip {
    font-size: 0.16rem;
    padding: 0.16rem 0.2rem;
    background: rgba(18, 105, 255, 0.05);
    box-sizing: border-box;
    margin: 0 0.12rem;
    border-radius: 0.03rem;
    border: 0.01rem dashed #1269ff;
  }
  .fen-diao{
    cursor: pointer;
    color: #1269ff;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
